import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  useLocation,
  useNavigate,
  useRoutes,
} from "react-router-dom";
import ProtectedRoute from "./protectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AllJobs from "./pages/AllJobs";
import Login from "./pages/Login";
import ScrollToTop from "./ScrollToTop";
import Applyjob from "./pages/Applyjob";
import CandidateDashboard from "./pages/CandidateDashboard.js";
import ApplicantRegistration from "./pages/ApplicantRegistration.jsx";
import ApplicantScoringScreenPreview from "./pages/ApplicantScoringScreen_preview";
import ApplicantApplicationPreview from "./pages/applicant_application_preview";
import AccountRecovery from "./pages/AccountRecovery.jsx";
import FeedBack from "./components/feedback/FeedBack.jsx";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";

const App = () => {
  let navigate = useNavigate();

  let routes = useRoutes([
    { path: "/", element: <Login /> },
    { path: "/all-jobs", element: <ProtectedRoute element={AllJobs} /> },
    { path: "/apply-for-post", element: <ProtectedRoute element={Applyjob} /> },
    { path: "/applicant-registration", element: <ApplicantRegistration /> },
    {
      path: "/applicantScoringScreen_Preview",
      element: <ProtectedRoute element={ApplicantScoringScreenPreview} />,
    },
    {
      path: "/applicant_application_preview",
      element: <ProtectedRoute element={ApplicantApplicationPreview} />,
    },
    { path: "/account-recovery", element: <AccountRecovery /> },
    { path: "/login", element: <Login /> },
    {
      path: "/candidateDashboard",
      element: <ProtectedRoute element={CandidateDashboard} />,
    },
    {
      path: "*",
      element: <NotFoundRedirect navigate={navigate} />,
    },
  ]);

  return routes;
};

const NotFoundRedirect = ({ navigate }) => {
  useEffect(() => {
    navigate("/login", { replace: true });
  }, [navigate]);
  return null; // Do not render anything while redirecting
};

const AppWrapper = () => {
  const [loading, setLoading] = useState(true);
  const location = useLocation(); // Now it's inside Router ✅

  const excludedPaths = [
    "/",
    "/applicant-registration",
    "/login",
    "/sign-up",
    "/account-recovery",
  ];

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <ErrorBoundary>
      <ScrollToTop />
      {/* {!excludedPaths.includes(location.pathname) && <FeedBack />} */}
      <App />
      <ToastContainer />
    </ErrorBoundary>
  );
};

const Root = () => {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
};

export default Root;
